import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Mail, MessageCircle, Clock } from 'lucide-react';
import { FaInstagram } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';


export const ContactUs = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-rose-50">
      <Header />

      {/* Hero Section */}
      <section className="pt-24 pb-16">
        <div className="container max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/80 border border-amber-200 rounded-full px-4 py-2 mb-6">
            <MessageCircle className="h-4 w-4 text-amber-600" />
            <span className="body-small text-amber-800 font-mono uppercase tracking-wider">
              Hubungi Kami
            </span>
          </div>

          <h1 className="heading-hero mb-6">
            Hubungi<br />
            Desy Clare
          </h1>

          <p className="body-large text-gray-600 mb-8 max-w-2xl mx-auto">
            Ada pertanyaan tentang numerologi atau butuh bantuan?
            <br />Kami siap membantu Anda mengenali diri Anda lebih baik melalui numerologi.
          </p>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="pb-20">
        <div className="container max-w-3xl mx-auto space-y-10">
          {/* Contact Information */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
            <h2 className="heading-2 mb-6 text-center">Informasi Kontak</h2>

            <div className="space-y-6">
              {/*Email*/}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <Mail className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Email</h3>
                  <a
                    href="mailto:desyclare@gmail.com"
                    className="body-medium text-blue-700 underline hover:text-blue-900"
                  >
                    desyclare@gmail.com
                  </a>
                  <p className="body-small text-gray-500">
                    Untuk pertanyaan umum dan konsultasi
                  </p>
                </div>
              </div>

              {/* INSTAGRAM */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center">
                  <FaInstagram className="h-6 w-6 text-pink-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Instagram</h3>
                  <a
                    href="https://instagram.com/desyclare"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="body-medium text-pink-700 underline hover:text-pink-900"
                  >
                    @desyclare
                  </a>
                  <p className="body-small text-gray-500">
                    Ikuti perjalanan spiritual dan update terbaru
                  </p>
                </div>
              </div>

              {/* TIKTOK */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-black/10 rounded-full flex items-center justify-center">
                  <SiTiktok className="h-6 w-6 text-black" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">TikTok</h3>
                  <a
                    href="https://www.tiktok.com/@desyclare"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="body-medium text-gray-800 underline hover:text-gray-900"
                  >
                    @desyclare
                  </a>
                  <p className="body-small text-gray-500">
                    Tonton konten numerologi dan inspirasi harian
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Response Time */}
          <div className="bg-gradient-to-r from-amber-50 to-rose-50 rounded-2xl border border-amber-200 p-8">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="h-6 w-6 text-amber-600" />
              <h3 className="heading-3">Waktu Respons</h3>
            </div>

            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="body-medium text-gray-700">Email</span>
                <span className="body-small font-semibold text-amber-700">24 jam</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="body-medium text-gray-700">Social Media</span>
                <span className="body-small font-semibold text-amber-700">2–6 jam</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="body-medium text-gray-700">Konsultasi</span>
                <span className="body-small font-semibold text-amber-700">1–3 hari</span>
              </div>
            </div>

            <div className="mt-6 p-4 bg-white/70 rounded-lg">
              <p className="body-small text-gray-600 italic">
                💫 Untuk pertanyaan numerologi mendetail, kami menyarankan konsultasi 
                personal untuk hasil yang lebih akurat dan mendalam.
              </p>
            </div>
          </div>

          {/* FAQ Quick Links */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
            <h3 className="heading-3 mb-4 text-center">Pertanyaan Umum</h3>
            <div className="space-y-3">
              <div className="p-3 bg-gray-50 rounded-lg">
                <p className="body-small font-medium text-gray-800 mb-1">
                  <b>Q: </b>Bagaimana cara kerja numerologi?
                </p>
                <p className="body-small text-gray-600">
                  <b>A: </b>Numerologi sudah diteliti sejak lama, dan bukan kebetulan semata. Setiap orang yang lahir di dunia ini sudah dipersiapkan untuk hadir dengan karakteristik tertentu. Kunjungi halaman Info untuk penjelasan lengkap.
                </p>
              </div>

              <div className="p-3 bg-gray-50 rounded-lg">
                <p className="body-small font-medium text-gray-800 mb-1">
                  <b>Q: </b>Apakah data saya aman?
                </p>
                <p className="body-small text-gray-600">
                  <b>A: </b>Ya, data pribadi Anda aman di platform ini, untuk selengkapnya dapat dilihat pada Kebijakan Privasi untuk detail keamanan.
                </p>
              </div>

              <div className="p-3 bg-gray-50 rounded-lg">
                <p className="body-small font-medium text-gray-800 mb-1">
                  <b>Q: </b>Bisakah melakukan konsultasi yang lebih detail?
                </p>
                <p className="body-small text-gray-600">
                  <b>A: </b>Ya, hubungi kami untuk jadwal konsultasi personal yang lebih rinci sehingga Anda bisa mendapatkan pembacaan numerologi Anda dengan lebih lengkap, bisa tanya jawab juga seputar kondisi spiritual personal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactUs;
